/**
 * Function to set an object's opacity by updating its group's children's materials
 */
const setOpacity = (object, opacity) => {
  if (object.material) {
    object.material.transparent = true
    object.material.opacity = opacity
  } else if (object.group) {
    object.group.children.forEach(child => {
      setOpacity(child, opacity)
    })
  } else if (object.children) {
    object.children.forEach(child => {
      setOpacity(child, opacity)
    })
  }
}

export { setOpacity }
